import React, { useState } from 'react'
import s from './ProfileItemCard.module.scss'
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_short_right.svg'

const ProfileItemCard = ({
	color,
	icon,
	title,
	subtitle,
	period,
	description,
	tag,
}) => {
	const [open, setOpen] = useState(false)
	const hasDetails = Boolean(description || tag)

	const toggle = () => {
		if (hasDetails) setOpen(prev => !prev)
	}

	return (
		<div className={`${s.card} ${color ? s[`card--${color}`] : ''}`}>
			<button
				type="button"
				className={s.row}
				onClick={toggle}
				aria-expanded={open}
				disabled={!hasDetails}
			>
				<span className={s.icon}>{icon}</span>

				<span className={s.body}>
					<span className={s.title}>{title}</span>

					{(subtitle || period) && (
						<span className={s.meta}>
							{subtitle && <span className={s.meta__text}>{subtitle}</span>}
							{subtitle && period && <span className={s.dot} />}
							{period && (
								<span className={s.meta__time}>
									<span className={s.meta__icon}>
										<ClockIcon />
									</span>
									<span className={s.meta__value}>{period}</span>
								</span>
							)}
						</span>
					)}
				</span>

				{hasDetails && (
					<span className={`${s.arrow} ${open ? s.arrowOpen : ''}`}>
						<ArrowIcon />
					</span>
				)}
			</button>

			{hasDetails && open && (
				<div className={s.details}>
					{tag && <span className={s.tag}>{tag}</span>}
					{description && <p className={s.descr}>{description}</p>}
				</div>
			)}
		</div>
	)
}

export default ProfileItemCard
